import { events } from './adviserProfilePicturesEditorActions'

const initialState = {
  editingPictures: false,
  editingProfilePicture: false,
  editingCompanyLogo: false,
  uploadingProfilePicture: false,
  profilePictureIsValid: true,
  oldProfilePicture: null
}

export default function (state = initialState, action) {
  const { edit, upload, set } = events
  switch (action.type) {
    case edit.profilePicture.start:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingProfilePicture = true
      state.profilePictures.oldProfilePicture = state.pendingApprovalProfile.profilePic
      return state
    case edit.profilePicture.stop:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingProfilePicture = false
      state.profilePictures.oldProfilePicture = null
      return state
    case edit.profilePicture.cancel:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingProfilePicture = false
      state.pendingApprovalProfile.profilePic = state.profilePictures.oldProfilePicture
      return state
    case set.profilePicture:
      state.pendingApprovalProfile.profilePic = action.image
      state.profilePictures.profilePictureIsValid = action.image.length > ('data:image/jpeg;base64,data').length
      state.edited = true
      return state
    case upload.profilePicture.uploading:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingProfilePicture = true
      return state
    case upload.profilePicture.uploaded:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingProfilePicture = false
      return state
    /* Company Logo Stuff */
    case edit.companyPicture.start:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingCompanyLogo = true
      state.profilePictures.oldCompanyPicture = state.pendingApprovalProfile.companyLogo
      return state
    case edit.companyPicture.stop:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingCompanyLogo = false
      state.profilePictures.oldCompanyPicture = null
      return state
    case edit.companyPicture.cancel:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingCompanyLogo = false
      state.pendingApprovalProfile.companyLogo = state.profilePictures.oldCompanyPicture
      return state
    case set.companyPicture:
      state.pendingApprovalProfile.companyLogo = action.image
      state.profilePictures.companyPictureIsValid = action.image.length > ('data:image/jpeg;base64,data').length
      state.edited = true
      return state
    case upload.companyPicture.uploading:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingCompanyPicture = true
      return state
    case upload.companyPicture.uploaded:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingCompanyPicture = false
      return state
  }
  return state
}
